$(function() {
    //  TRIGGER MAIN MENU
    $('#trigger_slide').on('click', function () {
        $(this).toggleClass('trigger-slide-toggled');
        $('body').toggleClass('overflow-hidden');
        $('#aside_nav').toggleClass('open');
        $('.backdrop').fadeToggle(100);
    });

    $('.backdrop').on('click', function () {
        $('#aside_nav').removeClass('open');
        $('#trigger_slide').removeClass('trigger-slide-toggled');
    });
});
